import type { FC, ReactNode } from 'react'
import { InternalNavigationContext } from './InternalNavigationContext'
import { useInternalAppNavigation } from './useInternalNavigation'

export const AppNavigationContext: FC<{ children: ReactNode }> = ({ children }) => {
  const value = useInternalAppNavigation()
  return <InternalNavigationContext.Provider value={value}>{children}</InternalNavigationContext.Provider>
}
